import dayjs from "dayjs";
import { ComboBoxCustom, ITableElement } from "shared/components";
import { columnsUsersTfeType } from "../types/columsUsersTfe.types";

export const  columnsGridUsersTfe = (userRoles: any[], handleRoleAssignment?: any): ITableElement<columnsUsersTfeType>[] => {

  const columnsTable = [
    {
      field: 'name',
      headerName: 'Nombre',
      minWidth: 200,
      sortable: 'name',
      renderCell(params: columnsUsersTfeType) {
        return (<>{params.name ?? ''}</>)
        },
    },
    {
      field: 'email',
      headerName: 'Email',
      minWidth: 200,
      sortable: 'email',
      renderCell(params: columnsUsersTfeType) {
        return (<>{params.email ?? ''}</>)
      },
    },
    {
      field: 'role',
      headerName: 'Rol',
      minWidth: 160,
      renderCell(params:columnsUsersTfeType) {
        return (
            <ComboBoxCustom 
                handleChange={handleRoleAssignment} 
                idsDoc={[params.id]} 
                currentValue={{name: params.rolName}}
                data={userRoles} 
                placeholder='Asignar'
                params={params}
            />
        )
      },
    },
  ];
  return columnsTable
} 
    